<template>
  <div id="grid-recepcion">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Listado de Cajas Recibidas</v-toolbar-title
          >
        </v-toolbar>
        <v-container grid-list-xl>
          <v-layout justify-center>
            <v-flex lg4>
              <p>Nivel: {{ this.detail.nivel }}</p>
            </v-flex>
            <v-flex lg4>
              <p>Tipo Prueba: {{ this.detail.tipoPrueba }}</p>
            </v-flex>
            <v-flex lg4>
              <p>Region: {{ this.detail.region }}</p>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-flex lg6>
              <p>Fecha Estimada Inicio: {{ this.detail.fechaInicio }}</p>
            </v-flex>
            <v-flex lg6>
              <p>Fecha Estimada Recepción: {{ this.detail.fechaRecepcion }}</p>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="visibleNew == true"
            color="primary"
            @click="newRecepcion()"
            >Nuevo</v-btn
          >
        </v-card-actions>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <div v-if="alertaRecibidos">
          <alert-empty></alert-empty>
        </div>
        <v-layout v-if="!alertaRecibidos" justify-center>
          <v-flex lg12>
            <v-spacer></v-spacer>
            <div v-if="loading">
              <loading></loading>
            </div>
            <v-data-table
              :headers="headers"
              :items="itemsRecepcion"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.fecha }}</td>
                <td class="text-xs-left">{{ props.item.numeroGuia }}</td>
                <td class="text-xs-left">
                  {{ props.item.rutEntrega }}{{ props.item.dvEntrega }}
                </td>
                <td class="text-xs-left">{{ props.item.cajasARecibir }}</td>
                <td class="text-xs-left">{{ props.item.observaciones }}</td>
                <v-btn
                  v-if="props.item.filename != null"
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Descargar archivo"
                  @click="downloadFile(props.item.id, props.item.filename)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "FormRecepcion",
  components: {
    AlertEmpty,
  },
  props: {
    rowsTable: String,
  },

  data() {
    return {
      loading: true,
      alertaRecibidos: false,
      dialog: false,
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Fecha Recepción",
          align: "left",
          sortable: false,
          value: "nivel",
        },
        {
          text: "N° Guía",
          sortable: false,
          value: "numeroGuia",
        },
        { text: "Rut que Recibió", sortable: false, value: "tipoDocumento" },
        {
          text: "Cajas Recibidas",
          sortable: false,
          value: "fechaEntrega",
        },
        {
          text: "Observaciones",
          sortable: false,
          value: "observaciones",
        },
        {
          text: "Archivos Cajas",
          sortable: false,
          value: "",
        },
      ],
      itemsRecepcion: [],
      detail: "",
      visibleNew: false,
      userlogged: "",
    };
  },
  created() {
    this.idSubitem = this.$route.params.idSubitem;
    this.idAcuerdo = this.$route.params.idAcuerdo;
    this.idContrato = this.$store.getters.contratoStored;
    this.userlogged = this.$store.getters.userLogged.tipo;

    if (this.userlogged == "PROVEEDOR" && this.getCodigoPerfil() != "LEC") {
  this.visibleNew = true;
} else {
  this.visibleNew = false;
}

    this.loadDataRecepcion();
    this.detail = this.loadDetailSubitem();
  },
  mounted() {},
  computed: {},
  methods: {
    getCodigoPerfil() {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const user = decoded.dto;
    // console.log("DEVODED USER:", user);
    return user.perfil.codigo;
  },
  isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    async loadDetailSubitem() {
      this.detail = await this.detailSubitem();
    },
    async loadDataRecepcion() {
      this.loading = true;
      this.itemsRecepcion = await this.loadRecepcion();
      if (this.itemsRecepcion.length > 0) {
        this.alertaRecibidos = false;
      } else {
        this.alertaRecibidos = true;
      }
      this.loading = false;
    },
    async detailSubitem() {
      return await axios
        .get("recepcion/" + this.idAcuerdo + "/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadRecepcion() {
      return await axios
        .get("recepcion/recibidos/" + this.idSubitem + "/" + this.idContrato)
        .then(function (response) {
          console.log(response.data);
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async downloadFile(id, filename) {
      let that = this;
      return await axios({
        url: "recepcion/download/" + id + "/" + this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    newRecepcion() {
      setTimeout(() => {
        this.$router.push({
          name: "RecepcionRegistra",
          params: {
            tipeView: "crear",
            idSubitem: this.idSubitem,
            idAcuerdo: this.idAcuerdo,
          },
        });
      }, 1000);
    },
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
